import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-affiliate-available-commission-card',
  templateUrl: './user-affiliate-available-commission-card.component.html',
  styleUrls: ['./user-affiliate-available-commission-card.component.scss'],
})
export class UserAffiliateAvailableCommissionCardComponent {
  @Input() data: any;

  constructor() {}
}
